export default {
  app: {
    golf: {
      title: 'Aikštelės informacija',
      hasEVChargingPoint: 'Elektromobilių įkrovimo stotelė',
      hasCaddieService: 'Kedžio paslauga',
      hasTrolley: 'Vežimėlis',
      hasBuggy: 'Bagis',
      hasClubRental: 'Lazdų nuoma',
      hasAcademy: 'Akademija',
      hasMarshal: 'Marshal',
      hasPGACertification: 'PGA sertifikatas',
      hasTrainingArea: 'Treniruočių aikštelė',
      hasRestaurant: 'Restoranas',
      hasHotel: 'Viešbutis',
      hasDogsOnCourse: 'Šunys aikštelėje',
      numberOfHoles: 'Skylių skaičius',
    },
  },
};
